import { AxiosError, AxiosResponse } from 'axios';
import instance, { ApiError } from 'src/api';
import { FetchAboutParams, FetchAboutResponse } from './about.types';

const companyAboutApiPath = (companyId: string) =>
  `/companies/${companyId}/about`;

export const getHotelAbout = async ({
  companyId,
}: FetchAboutParams): Promise<AxiosResponse<FetchAboutResponse & ApiError>> => {
  return instance
    .get<FetchAboutResponse>(companyAboutApiPath(companyId))
    .catch((e) => e.response as AxiosError<ApiError> as never);
};
